export default __webpack_public_path__ + "static/media/banner.2990d09e.png";